import React, { useState, useEffect } from 'react';
import { API_URL } from '../config/api';

// Common country codes with names (sorted alphabetically by name)
const COUNTRY_LIST = [
  // A
  { code: 'al', name: 'Albania', flag: '🇦🇱' },
  { code: 'dz', name: 'Algeria', flag: '🇩🇿' },
  { code: 'ad', name: 'Andorra', flag: '🇦🇩' },
  { code: 'ao', name: 'Angola', flag: '🇦🇴' },
  { code: 'ag', name: 'Antigua and Barbuda', flag: '🇦🇬' },
  { code: 'ar', name: 'Argentina', flag: '🇦🇷' },
  { code: 'am', name: 'Armenia', flag: '🇦🇲' },
  { code: 'au', name: 'Australia', flag: '🇦🇺' },
  { code: 'at', name: 'Austria', flag: '🇦🇹' },
  { code: 'az', name: 'Azerbaijan', flag: '🇦🇿' },
  // B
  { code: 'bs', name: 'Bahamas', flag: '🇧🇸' },
  { code: 'bh', name: 'Bahrain', flag: '🇧🇭' },
  { code: 'bd', name: 'Bangladesh', flag: '🇧🇩' },
  { code: 'bb', name: 'Barbados', flag: '🇧🇧' },
  { code: 'by', name: 'Belarus', flag: '🇧🇾' },
  { code: 'be', name: 'Belgium', flag: '🇧🇪' },
  { code: 'bz', name: 'Belize', flag: '🇧🇿' },
  { code: 'bj', name: 'Benin', flag: '🇧🇯' },
  { code: 'bt', name: 'Bhutan', flag: '🇧🇹' },
  { code: 'bo', name: 'Bolivia', flag: '🇧🇴' },
  { code: 'ba', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
  { code: 'bw', name: 'Botswana', flag: '🇧🇼' },
  { code: 'br', name: 'Brazil', flag: '🇧🇷' },
  { code: 'bn', name: 'Brunei', flag: '🇧🇳' },
  { code: 'bg', name: 'Bulgaria', flag: '🇧🇬' },
  { code: 'bf', name: 'Burkina Faso', flag: '🇧🇫' },
  { code: 'bi', name: 'Burundi', flag: '🇧🇮' },
  // C
  { code: 'kh', name: 'Cambodia', flag: '🇰🇭' },
  { code: 'cm', name: 'Cameroon', flag: '🇨🇲' },
  { code: 'ca', name: 'Canada', flag: '🇨🇦' },
  { code: 'cv', name: 'Cape Verde', flag: '🇨🇻' },
  { code: 'cf', name: 'Central African Republic', flag: '🇨🇫' },
  { code: 'td', name: 'Chad', flag: '🇹🇩' },
  { code: 'cl', name: 'Chile', flag: '🇨🇱' },
  { code: 'cn', name: 'China', flag: '🇨🇳' },
  { code: 'co', name: 'Colombia', flag: '🇨🇴' },
  { code: 'km', name: 'Comoros', flag: '🇰🇲' },
  { code: 'cg', name: 'Congo', flag: '🇨🇬' },
  { code: 'cd', name: 'Congo (DRC)', flag: '🇨🇩' },
  { code: 'cr', name: 'Costa Rica', flag: '🇨🇷' },
  { code: 'hr', name: 'Croatia', flag: '🇭🇷' },
  { code: 'cu', name: 'Cuba', flag: '🇨🇺' },
  { code: 'cy', name: 'Cyprus', flag: '🇨🇾' },
  { code: 'cz', name: 'Czech Republic', flag: '🇨🇿' },
  // D
  { code: 'dk', name: 'Denmark', flag: '🇩🇰' },
  { code: 'dj', name: 'Djibouti', flag: '🇩🇯' },
  { code: 'dm', name: 'Dominica', flag: '🇩🇲' },
  { code: 'do', name: 'Dominican Republic', flag: '🇩🇴' },
  // E
  { code: 'ec', name: 'Ecuador', flag: '🇪🇨' },
  { code: 'eg', name: 'Egypt', flag: '🇪🇬' },
  { code: 'sv', name: 'El Salvador', flag: '🇸🇻' },
  { code: 'gq', name: 'Equatorial Guinea', flag: '🇬🇶' },
  { code: 'er', name: 'Eritrea', flag: '🇪🇷' },
  { code: 'ee', name: 'Estonia', flag: '🇪🇪' },
  { code: 'sz', name: 'Eswatini', flag: '🇸🇿' },
  { code: 'et', name: 'Ethiopia', flag: '🇪🇹' },
  // F
  { code: 'fj', name: 'Fiji', flag: '🇫🇯' },
  { code: 'fi', name: 'Finland', flag: '🇫🇮' },
  { code: 'fr', name: 'France', flag: '🇫🇷' },
  // G
  { code: 'ga', name: 'Gabon', flag: '🇬🇦' },
  { code: 'gm', name: 'Gambia', flag: '🇬🇲' },
  { code: 'ge', name: 'Georgia', flag: '🇬🇪' },
  { code: 'de', name: 'Germany', flag: '🇩🇪' },
  { code: 'gh', name: 'Ghana', flag: '🇬🇭' },
  { code: 'gr', name: 'Greece', flag: '🇬🇷' },
  { code: 'gd', name: 'Grenada', flag: '🇬🇩' },
  { code: 'gt', name: 'Guatemala', flag: '🇬🇹' },
  { code: 'gn', name: 'Guinea', flag: '🇬🇳' },
  { code: 'gw', name: 'Guinea-Bissau', flag: '🇬🇼' },
  { code: 'gy', name: 'Guyana', flag: '🇬🇾' },
  // H
  { code: 'ht', name: 'Haiti', flag: '🇭🇹' },
  { code: 'hn', name: 'Honduras', flag: '🇭🇳' },
  { code: 'hk', name: 'Hong Kong', flag: '🇭🇰' },
  { code: 'hu', name: 'Hungary', flag: '🇭🇺' },
  // I
  { code: 'is', name: 'Iceland', flag: '🇮🇸' },
  { code: 'in', name: 'India', flag: '🇮🇳' },
  { code: 'id', name: 'Indonesia', flag: '🇮🇩' },
  { code: 'ir', name: 'Iran', flag: '🇮🇷' },
  { code: 'iq', name: 'Iraq', flag: '🇮🇶' },
  { code: 'ie', name: 'Ireland', flag: '🇮🇪' },
  { code: 'il', name: 'Israel', flag: '🇮🇱' },
  { code: 'it', name: 'Italy', flag: '🇮🇹' },
  { code: 'ci', name: 'Ivory Coast', flag: '🇨🇮' },
  // J
  { code: 'jm', name: 'Jamaica', flag: '🇯🇲' },
  { code: 'jp', name: 'Japan', flag: '🇯🇵' },
  { code: 'jo', name: 'Jordan', flag: '🇯🇴' },
  // K
  { code: 'kz', name: 'Kazakhstan', flag: '🇰🇿' },
  { code: 'ke', name: 'Kenya', flag: '🇰🇪' },
  { code: 'ki', name: 'Kiribati', flag: '🇰🇮' },
  { code: 'kw', name: 'Kuwait', flag: '🇰🇼' },
  { code: 'kg', name: 'Kyrgyzstan', flag: '🇰🇬' },
  // L
  { code: 'la', name: 'Laos', flag: '🇱🇦' },
  { code: 'lv', name: 'Latvia', flag: '🇱🇻' },
  { code: 'lb', name: 'Lebanon', flag: '🇱🇧' },
  { code: 'ls', name: 'Lesotho', flag: '🇱🇸' },
  { code: 'lr', name: 'Liberia', flag: '🇱🇷' },
  { code: 'ly', name: 'Libya', flag: '🇱🇾' },
  { code: 'li', name: 'Liechtenstein', flag: '🇱🇮' },
  { code: 'lt', name: 'Lithuania', flag: '🇱🇹' },
  { code: 'lu', name: 'Luxembourg', flag: '🇱🇺' },
  // M
  { code: 'mo', name: 'Macau', flag: '🇲🇴' },
  { code: 'mg', name: 'Madagascar', flag: '🇲🇬' },
  { code: 'mw', name: 'Malawi', flag: '🇲🇼' },
  { code: 'my', name: 'Malaysia', flag: '🇲🇾' },
  { code: 'mv', name: 'Maldives', flag: '🇲🇻' },
  { code: 'ml', name: 'Mali', flag: '🇲🇱' },
  { code: 'mt', name: 'Malta', flag: '🇲🇹' },
  { code: 'mh', name: 'Marshall Islands', flag: '🇲🇭' },
  { code: 'mr', name: 'Mauritania', flag: '🇲🇷' },
  { code: 'mu', name: 'Mauritius', flag: '🇲🇺' },
  { code: 'mx', name: 'Mexico', flag: '🇲🇽' },
  { code: 'fm', name: 'Micronesia', flag: '🇫🇲' },
  { code: 'md', name: 'Moldova', flag: '🇲🇩' },
  { code: 'mc', name: 'Monaco', flag: '🇲🇨' },
  { code: 'mn', name: 'Mongolia', flag: '🇲🇳' },
  { code: 'me', name: 'Montenegro', flag: '🇲🇪' },
  { code: 'ma', name: 'Morocco', flag: '🇲🇦' },
  { code: 'mz', name: 'Mozambique', flag: '🇲🇿' },
  { code: 'mm', name: 'Myanmar', flag: '🇲🇲' },
  // N
  { code: 'na', name: 'Namibia', flag: '🇳🇦' },
  { code: 'nr', name: 'Nauru', flag: '🇳🇷' },
  { code: 'np', name: 'Nepal', flag: '🇳🇵' },
  { code: 'nl', name: 'Netherlands', flag: '🇳🇱' },
  { code: 'nz', name: 'New Zealand', flag: '🇳🇿' },
  { code: 'ni', name: 'Nicaragua', flag: '🇳🇮' },
  { code: 'ne', name: 'Niger', flag: '🇳🇪' },
  { code: 'ng', name: 'Nigeria', flag: '🇳🇬' },
  { code: 'kp', name: 'North Korea', flag: '🇰🇵' },
  { code: 'mk', name: 'North Macedonia', flag: '🇲🇰' },
  { code: 'no', name: 'Norway', flag: '🇳🇴' },
  // O
  { code: 'om', name: 'Oman', flag: '🇴🇲' },
  // P
  { code: 'pk', name: 'Pakistan', flag: '🇵🇰' },
  { code: 'pw', name: 'Palau', flag: '🇵🇼' },
  { code: 'ps', name: 'Palestine', flag: '🇵🇸' },
  { code: 'pa', name: 'Panama', flag: '🇵🇦' },
  { code: 'pg', name: 'Papua New Guinea', flag: '🇵🇬' },
  { code: 'py', name: 'Paraguay', flag: '🇵🇾' },
  { code: 'pe', name: 'Peru', flag: '🇵🇪' },
  { code: 'ph', name: 'Philippines', flag: '🇵🇭' },
  { code: 'pl', name: 'Poland', flag: '🇵🇱' },
  { code: 'pt', name: 'Portugal', flag: '🇵🇹' },
  { code: 'pr', name: 'Puerto Rico', flag: '🇵🇷' },
  // Q
  { code: 'qa', name: 'Qatar', flag: '🇶🇦' },
  // R
  { code: 'ro', name: 'Romania', flag: '🇷🇴' },
  { code: 'ru', name: 'Russia', flag: '🇷🇺' },
  { code: 'rw', name: 'Rwanda', flag: '🇷🇼' },
  // S
  { code: 'kn', name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
  { code: 'lc', name: 'Saint Lucia', flag: '🇱🇨' },
  { code: 'vc', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
  { code: 'ws', name: 'Samoa', flag: '🇼🇸' },
  { code: 'sm', name: 'San Marino', flag: '🇸🇲' },
  { code: 'st', name: 'Sao Tome and Principe', flag: '🇸🇹' },
  { code: 'sa', name: 'Saudi Arabia', flag: '🇸🇦' },
  { code: 'sn', name: 'Senegal', flag: '🇸🇳' },
  { code: 'rs', name: 'Serbia', flag: '🇷🇸' },
  { code: 'sc', name: 'Seychelles', flag: '🇸🇨' },
  { code: 'sl', name: 'Sierra Leone', flag: '🇸🇱' },
  { code: 'sg', name: 'Singapore', flag: '🇸🇬' },
  { code: 'sk', name: 'Slovakia', flag: '🇸🇰' },
  { code: 'si', name: 'Slovenia', flag: '🇸🇮' },
  { code: 'sb', name: 'Solomon Islands', flag: '🇸🇧' },
  { code: 'so', name: 'Somalia', flag: '🇸🇴' },
  { code: 'za', name: 'South Africa', flag: '🇿🇦' },
  { code: 'kr', name: 'South Korea', flag: '🇰🇷' },
  { code: 'ss', name: 'South Sudan', flag: '🇸🇸' },
  { code: 'es', name: 'Spain', flag: '🇪🇸' },
  { code: 'lk', name: 'Sri Lanka', flag: '🇱🇰' },
  { code: 'sd', name: 'Sudan', flag: '🇸🇩' },
  { code: 'sr', name: 'Suriname', flag: '🇸🇷' },
  { code: 'se', name: 'Sweden', flag: '🇸🇪' },
  { code: 'ch', name: 'Switzerland', flag: '🇨🇭' },
  { code: 'sy', name: 'Syria', flag: '🇸🇾' },
  // T
  { code: 'tw', name: 'Taiwan', flag: '🇹🇼' },
  { code: 'tj', name: 'Tajikistan', flag: '🇹🇯' },
  { code: 'tz', name: 'Tanzania', flag: '🇹🇿' },
  { code: 'th', name: 'Thailand', flag: '🇹🇭' },
  { code: 'tl', name: 'Timor-Leste', flag: '🇹🇱' },
  { code: 'tg', name: 'Togo', flag: '🇹🇬' },
  { code: 'to', name: 'Tonga', flag: '🇹🇴' },
  { code: 'tt', name: 'Trinidad and Tobago', flag: '🇹🇹' },
  { code: 'tn', name: 'Tunisia', flag: '🇹🇳' },
  { code: 'tr', name: 'Turkey', flag: '🇹🇷' },
  { code: 'tm', name: 'Turkmenistan', flag: '🇹🇲' },
  { code: 'tv', name: 'Tuvalu', flag: '🇹🇻' },
  // U
  { code: 'ug', name: 'Uganda', flag: '🇺🇬' },
  { code: 'ua', name: 'Ukraine', flag: '🇺🇦' },
  { code: 'ae', name: 'UAE', flag: '🇦🇪' },
  { code: 'gb', name: 'United Kingdom', flag: '🇬🇧' },
  { code: 'us', name: 'United States', flag: '🇺🇸' },
  { code: 'uy', name: 'Uruguay', flag: '🇺🇾' },
  { code: 'uz', name: 'Uzbekistan', flag: '🇺🇿' },
  // V
  { code: 'vu', name: 'Vanuatu', flag: '🇻🇺' },
  { code: 'va', name: 'Vatican City', flag: '🇻🇦' },
  { code: 've', name: 'Venezuela', flag: '🇻🇪' },
  { code: 'vn', name: 'Vietnam', flag: '🇻🇳' },
  // Y
  { code: 'ye', name: 'Yemen', flag: '🇾🇪' },
  // Z
  { code: 'zm', name: 'Zambia', flag: '🇿🇲' },
  { code: 'zw', name: 'Zimbabwe', flag: '🇿🇼' },
  // Other (at the end)
  { code: 'other', name: 'Other', flag: '🌍' },
];

interface AudienceEntry {
  code: string;
  percentage: number;
}

interface Collaboration {
  _id: string;
  audienceData?: Record<string, number | { percentage: number }>;
  maxCPM?: number;
  cpm?: number;
  creatorName?: string;
  handle?: string;
}

interface AudienceEditModalProps {
  collaboration: Collaboration;
  onClose: () => void;
  onSaved: () => void;
}

const AudienceEditModal: React.FC<AudienceEditModalProps> = ({
  collaboration,
  onClose,
  onSaved,
}) => {
  const [audiences, setAudiences] = useState<AudienceEntry[]>([]);
  const [newCountry, setNewCountry] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState<{ maxCPM: number; previousMaxCPM: number } | null>(null);
  const [applyToAllLoading, setApplyToAllLoading] = useState(false);
  const [showApplyToAllConfirm, setShowApplyToAllConfirm] = useState(false);
  const [applyToAllResult, setApplyToAllResult] = useState<{ count: number; maxCPM: number } | null>(null);

  // Initialize audiences from collaboration data
  useEffect(() => {
    if (collaboration.audienceData) {
      let audienceObj = collaboration.audienceData;
      if (typeof audienceObj === 'string') {
        try {
          audienceObj = JSON.parse(audienceObj);
        } catch {
          return;
        }
      }

      const entries: AudienceEntry[] = Object.entries(audienceObj)
        .filter(([code]) => code.toLowerCase() !== 'other') // Exclude 'other' - it's auto-calculated
        .map(([code, value]) => {
          let percentage = typeof value === 'object' && value !== null
            ? (value as { percentage: number }).percentage || 0
            : parseFloat(String(value)) || 0;

          // Convert 0-1 range to percentage if needed
          if (percentage <= 1) {
            percentage = percentage * 100;
          }

          // Round to integer
          percentage = Math.round(percentage);

          return { code: code.toLowerCase(), percentage };
        })
        .sort((a, b) => b.percentage - a.percentage);

      setAudiences(entries);
    }
  }, [collaboration.audienceData]);

  // Get country info by code
  const getCountryInfo = (code: string) => {
    return COUNTRY_LIST.find(c => c.code === code.toLowerCase()) || {
      code,
      name: code.toUpperCase(),
      flag: '🏳️'
    };
  };

  // Calculate total percentage
  const totalPercentage = audiences.reduce((sum, a) => sum + a.percentage, 0);
  const isOverLimit = totalPercentage > 100;
  const otherPercentage = Math.max(0, 100 - totalPercentage);

  // Get available countries (not already added)
  const availableCountries = COUNTRY_LIST.filter(
    c => c.code !== 'other' && !audiences.some(a => a.code === c.code)
  );

  // Handle percentage change
  const handlePercentageChange = (index: number, value: string) => {
    const numValue = Math.round(parseFloat(value) || 0);
    const newAudiences = [...audiences];
    newAudiences[index].percentage = Math.max(0, Math.min(100, numValue));
    setAudiences(newAudiences);
    setResult(null);
    setError('');
  };

  // Add new country
  const handleAddCountry = () => {
    if (newCountry && !audiences.some(a => a.code === newCountry)) {
      setAudiences([...audiences, { code: newCountry, percentage: 0 }]);
      setNewCountry('');
      setResult(null);
    }
  };

  // Remove country
  const handleRemoveCountry = (index: number) => {
    const newAudiences = audiences.filter((_, i) => i !== index);
    setAudiences(newAudiences);
    setResult(null);
  };

  // Change country code
  const handleCountryChange = (index: number, newCode: string) => {
    if (newCode && !audiences.some((a, i) => i !== index && a.code === newCode)) {
      const newAudiences = [...audiences];
      newAudiences[index].code = newCode;
      setAudiences(newAudiences);
      setResult(null);
    }
  };

  // Get available countries for a specific row (excluding other rows' countries)
  const getAvailableCountriesForRow = (currentIndex: number) => {
    return COUNTRY_LIST.filter(
      c => c.code !== 'other' &&
           (c.code === audiences[currentIndex]?.code || !audiences.some(a => a.code === c.code))
    );
  };

  // Handle recalculate
  const handleRecalculate = async () => {
    setIsLoading(true);
    setError('');
    setResult(null);

    try {
      // Build audience data object (convert percentage to 0-1 range)
      const audienceData: Record<string, number> = {};

      audiences.forEach(a => {
        audienceData[a.code] = a.percentage / 100;
      });

      // Add "other" if there's remaining percentage
      if (otherPercentage > 0) {
        audienceData['other'] = otherPercentage / 100;
      }

      const response = await fetch(`${API_URL}/api/collaborations/${collaboration._id}/audience`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({ audienceData })
      });

      const data = await response.json();

      if (data.success) {
        setResult({
          maxCPM: data.data.maxCPM,
          previousMaxCPM: collaboration.maxCPM || 0
        });
        onSaved();
      } else {
        throw new Error(data.error || 'Failed to update audience data');
      }
    } catch (err: unknown) {
      const errorMessage = err instanceof Error ? err.message : 'An error occurred';
      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  // Handle apply to all collaborations with the same handle
  const handleApplyToAll = async () => {
    if (!collaboration.handle) {
      setError('No handle found for this collaboration');
      return;
    }

    setApplyToAllLoading(true);
    setError('');
    setApplyToAllResult(null);
    setResult(null);

    try {
      const audienceData: Record<string, number> = {};
      audiences.forEach(a => {
        audienceData[a.code] = a.percentage / 100;
      });
      if (otherPercentage > 0) {
        audienceData['other'] = otherPercentage / 100;
      }

      const response = await fetch(`${API_URL}/api/collaborations/bulk-update-audience-by-handle`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        },
        body: JSON.stringify({
          handle: collaboration.handle,
          audienceData
        })
      });

      const data = await response.json();

      if (data.success) {
        setApplyToAllResult({
          count: data.data.updatedCount,
          maxCPM: data.data.maxCPM
        });
        onSaved();
      } else {
        throw new Error(data.error || 'Failed to apply to all');
      }
    } catch (err: unknown) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setApplyToAllLoading(false);
      setShowApplyToAllConfirm(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content audience-edit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Edit Audience Distribution</h2>
          <button className="modal-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="modal-body">
          {collaboration.creatorName && (
            <p className="modal-subtitle">
              Creator: <strong>{collaboration.creatorName}</strong>
            </p>
          )}

          <div className="audience-list">
            <div className="audience-header">
              <span>Country</span>
              <span>Percentage</span>
              <span></span>
            </div>

            {audiences.map((audience, index) => {
              const country = getCountryInfo(audience.code);
              const availableForRow = getAvailableCountriesForRow(index);
              return (
                <div key={`${audience.code}-${index}`} className="audience-row">
                  <div className="country-select-wrapper">
                    <select
                      value={audience.code}
                      onChange={(e) => handleCountryChange(index, e.target.value)}
                      className="country-select-inline"
                    >
                      {availableForRow.map(c => (
                        <option key={c.code} value={c.code}>
                          {c.flag} {c.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="percentage-input-wrapper">
                    <input
                      type="number"
                      min="0"
                      max="100"
                      step="1"
                      value={audience.percentage}
                      onChange={(e) => handlePercentageChange(index, e.target.value)}
                      className="percentage-input"
                    />
                    <span className="percentage-symbol">%</span>
                  </div>
                  <button
                    className="remove-country-btn"
                    onClick={() => handleRemoveCountry(index)}
                    title="Remove country"
                  >
                    ×
                  </button>
                </div>
              );
            })}

            {/* Other row (auto-calculated) */}
            {otherPercentage > 0 && !isOverLimit && (
              <div className="audience-row other-row">
                <div className="country-info">
                  <span className="country-flag">🌍</span>
                  <span className="country-name">Other</span>
                </div>
                <div className="percentage-display">
                  {Math.round(otherPercentage)}%
                </div>
                <div className="auto-label">(auto)</div>
              </div>
            )}
          </div>

          {/* Add country section */}
          <div className="add-country-section">
            <select
              value={newCountry}
              onChange={(e) => setNewCountry(e.target.value)}
              className="country-select"
            >
              <option value="">Select country to add...</option>
              {availableCountries.map(c => (
                <option key={c.code} value={c.code}>
                  {c.flag} {c.name}
                </option>
              ))}
            </select>
            <button
              className="btn-secondary add-country-btn"
              onClick={handleAddCountry}
              disabled={!newCountry}
            >
              Add
            </button>
          </div>

          {/* Total summary */}
          <div className={`total-summary ${isOverLimit ? 'error' : ''}`}>
            <span>Total: {Math.round(totalPercentage)}%</span>
            {isOverLimit && (
              <span className="warning-text">
                ⚠️ Total exceeds 100%. Please adjust.
              </span>
            )}
            {!isOverLimit && otherPercentage > 0 && (
              <span className="info-text">
                (Other: {Math.round(otherPercentage)}%)
              </span>
            )}
          </div>

          {/* Error message */}
          {error && <div className="error-message">{error}</div>}

          {/* Result display */}
          {result && (
            <div className="result-display">
              <div className="result-item">
                <span className="result-label">Previous maxCPM:</span>
                <span className="result-value">${result.previousMaxCPM.toFixed(2)}</span>
              </div>
              <div className="result-item highlight">
                <span className="result-label">New maxCPM:</span>
                <span className="result-value">${result.maxCPM.toFixed(2)}</span>
              </div>
              <div className="result-item">
                <span className="result-label">Change:</span>
                <span className={`result-value ${result.maxCPM > result.previousMaxCPM ? 'positive' : result.maxCPM < result.previousMaxCPM ? 'negative' : ''}`}>
                  {result.maxCPM > result.previousMaxCPM ? '+' : ''}
                  ${(result.maxCPM - result.previousMaxCPM).toFixed(2)}
                </span>
              </div>
            </div>
          )}

          {/* Apply to all result display */}
          {applyToAllResult && (
            <div className="result-display bulk-result">
              <div className="result-item highlight">
                <span className="result-label">Updated collaborations:</span>
                <span className="result-value">{applyToAllResult.count}</span>
              </div>
              <div className="result-item">
                <span className="result-label">New maxCPM:</span>
                <span className="result-value">${applyToAllResult.maxCPM.toFixed(2)}</span>
              </div>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>
            Close
          </button>
          {collaboration.handle && (
            <button
              className="btn-warning"
              onClick={() => setShowApplyToAllConfirm(true)}
              disabled={isLoading || applyToAllLoading || isOverLimit || audiences.length === 0}
            >
              {applyToAllLoading ? 'Applying...' : `Apply to All (@${collaboration.handle})`}
            </button>
          )}
          <button
            className="btn-primary"
            onClick={handleRecalculate}
            disabled={isLoading || isOverLimit || audiences.length === 0}
          >
            {isLoading ? 'Calculating...' : 'Recalculate maxCPM'}
          </button>
        </div>

        {/* Apply to all confirmation dialog */}
        {showApplyToAllConfirm && (
          <div className="confirm-overlay" onClick={() => setShowApplyToAllConfirm(false)}>
            <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
              <h3>Apply to All Collaborations</h3>
              <p>
                This will apply the current audience distribution to <strong>all collaborations</strong> with handle <strong>@{collaboration.handle}</strong>.
              </p>
              <p className="confirm-warning">This action will update maxCPM for all matching collaborations.</p>
              <div className="confirm-buttons">
                <button className="btn-secondary" onClick={() => setShowApplyToAllConfirm(false)}>
                  Cancel
                </button>
                <button className="btn-warning" onClick={handleApplyToAll} disabled={applyToAllLoading}>
                  {applyToAllLoading ? 'Applying...' : 'Apply to All'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      <style>{`
        .audience-edit-modal {
          max-width: 500px;
          width: 90%;
        }

        .modal-subtitle {
          margin: 0 0 16px 0;
          color: #666;
        }

        .audience-list {
          border: 1px solid #e0e0e0;
          border-radius: 8px;
          overflow: hidden;
        }

        .audience-header {
          display: grid;
          grid-template-columns: 1fr 100px 40px;
          gap: 8px;
          padding: 8px 12px;
          background: #f5f5f5;
          font-weight: 600;
          font-size: 12px;
          color: #666;
        }

        .audience-row {
          display: grid;
          grid-template-columns: 1fr 100px 40px;
          gap: 8px;
          padding: 8px 12px;
          align-items: center;
          border-top: 1px solid #e0e0e0;
        }

        .audience-row:first-of-type {
          border-top: none;
        }

        .other-row {
          background: #f9f9f9;
        }

        .country-info {
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .country-select-wrapper {
          width: 100%;
        }

        .country-select-inline {
          width: 100%;
          padding: 6px 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          background: white;
          cursor: pointer;
        }

        .country-select-inline:focus {
          outline: none;
          border-color: #007bff;
        }

        .country-select-inline:hover {
          border-color: #999;
        }

        .country-flag {
          font-size: 20px;
        }

        .country-name {
          font-size: 14px;
        }

        .percentage-input-wrapper {
          display: flex;
          align-items: center;
          gap: 4px;
        }

        .percentage-input {
          width: 70px;
          padding: 6px 8px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
          text-align: right;
        }

        .percentage-input:focus {
          outline: none;
          border-color: #007bff;
        }

        .percentage-symbol {
          color: #666;
        }

        .percentage-display {
          font-size: 14px;
          text-align: right;
          padding-right: 20px;
          color: #666;
        }

        .auto-label {
          font-size: 11px;
          color: #999;
        }

        .remove-country-btn {
          width: 28px;
          height: 28px;
          border: none;
          background: #ff4444;
          color: white;
          border-radius: 4px;
          cursor: pointer;
          font-size: 18px;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .remove-country-btn:hover {
          background: #cc0000;
        }

        .add-country-section {
          display: flex;
          gap: 8px;
          margin-top: 12px;
        }

        .country-select {
          flex: 1;
          padding: 8px 12px;
          border: 1px solid #ddd;
          border-radius: 4px;
          font-size: 14px;
        }

        .add-country-btn {
          padding: 8px 16px;
        }

        .total-summary {
          margin-top: 16px;
          padding: 12px;
          background: #f0f7ff;
          border-radius: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-weight: 600;
        }

        .total-summary.error {
          background: #fff0f0;
          color: #cc0000;
        }

        .warning-text {
          color: #cc0000;
          font-size: 13px;
        }

        .info-text {
          color: #666;
          font-weight: normal;
          font-size: 13px;
        }

        .result-display {
          margin-top: 16px;
          padding: 12px;
          background: #f0fff0;
          border-radius: 8px;
          border: 1px solid #90EE90;
        }

        .result-item {
          display: flex;
          justify-content: space-between;
          padding: 4px 0;
        }

        .result-item.highlight {
          font-weight: 600;
          font-size: 16px;
        }

        .result-label {
          color: #666;
        }

        .result-value {
          font-weight: 600;
        }

        .result-value.positive {
          color: #22c55e;
        }

        .result-value.negative {
          color: #ef4444;
        }

        .modal-footer {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          padding: 16px 20px;
          border-top: 1px solid #e0e0e0;
          flex-wrap: wrap;
        }

        .btn-warning {
          background: #f59e0b;
          color: white;
          border: none;
          padding: 8px 16px;
          border-radius: 6px;
          cursor: pointer;
          font-weight: 500;
        }

        .btn-warning:hover {
          background: #d97706;
        }

        .btn-warning:disabled {
          background: #fcd34d;
          cursor: not-allowed;
        }

        .bulk-result {
          background: #fff7ed;
          border-color: #fdba74;
        }

        .confirm-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1001;
        }

        .confirm-dialog {
          background: white;
          border-radius: 12px;
          padding: 24px;
          max-width: 400px;
          width: 90%;
          box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1);
        }

        .confirm-dialog h3 {
          margin: 0 0 16px 0;
          font-size: 18px;
          color: #111;
        }

        .confirm-dialog p {
          margin: 0 0 12px 0;
          color: #444;
          line-height: 1.5;
        }

        .confirm-warning {
          color: #b45309 !important;
          font-size: 13px;
          background: #fef3c7;
          padding: 8px 12px;
          border-radius: 6px;
        }

        .confirm-buttons {
          display: flex;
          gap: 12px;
          justify-content: flex-end;
          margin-top: 20px;
        }
      `}</style>
    </div>
  );
};

export default AudienceEditModal;
